import React from 'react';
import AutocompleteFilter from '../common/autocompleteFilter';
import Constants from '../../containers/function/constants.js';

const Filters = (props) => {
  const { typeTab } = props;
  const { taskManagerTabs  } = Constants;
  let showAnullButton = true;
  let showFilterState = true;
  let showFilterManager = true;
  let showFilterWorkingShiftGroup = false;

  switch (typeTab) {
    case taskManagerTabs.TAB_NOTIFICATIONS:
      showAnullButton = false;
      showFilterState = false;
      showFilterManager = false;
      break;
  }

  return (
    <section className="module-filter top buttons-top buttons-top-filters" style={{...props.containerStyle}}>
      {showAnullButton && (props.permits.includes("incidentannull") == true) && (
        <div className={"flex annull_button" + (props.selectedAnnuls > 0 ? "" : " disabled")}>
            <div className="box-form">
              <ul className="buttom_menu">
                <li onClick={props.selectedAnnuls > 0 ? props.handleAnnulTasks : null}>
                  <a
                    className="buttom_menu"
                    onClick={null}>
                    {props.language.tasks_manager.filters.annulTasks}
                  </a>
                </li>
              </ul>
            </div>
        </div>
      )}
      <div className="tasks_manager_second_filters">
        {
          showFilterState && (
            <AutocompleteFilter
              id="stateFilter"
              label={props.language.tasks_manager.filters.state}
              selectedKey={props.filters.otherFilters.state ? props.filters.otherFilters.state : ""}
              options={props.filters.datos ? props.filters.datos.states : []}
              onChange={props.handleSubmit}
              className={"stateFilter fix-super-wide"}
              dataAttributes={{
                "data-selectid": "state",
                "data-selectfilter": true,
                "data-value": (option) => option.key,
              }}
            />
          )
        }
        {
          showFilterManager && (
            <AutocompleteFilter
              id="managerFilter"
              label={props.language.tasks_manager.filters.manager}
              selectedKey={props.filters.otherFilters.managerId ? props.filters.otherFilters.managerId : ""}
              options={props.filters.datos ? props.filters.datos.managers : []}
              onChange={props.handleSubmit}
              className={"managerFilter"}
              dataAttributes={{
                "data-selectid": "managerId",
                "data-selectfilter": true,
                "data-value": (option) => option.key,
              }}
            />
          )
        }
        <AutocompleteFilter
          id="vehicleFilter"
          label={props.language.tasks_manager.filters.vehicle}
          selectedKey={props.filters.otherFilters.vehicleId ? props.filters.otherFilters.vehicleId : ""}
          options={props.filters.datos ? props.filters.datos.vehicles : []}
          onChange={props.handleSubmit}
          className={"vehicleFilter"}
          dataAttributes={{
            "data-selectid": "vehicleId",
            "data-selectfilter": true,
            "data-value": (option) => option.key,
          }}
    />
        <AutocompleteFilter
          id="geoZoneFilter"
          label={props.language.tasks_manager.filters.geoZone}
          selectedKey={props.filters.otherFilters.geoZoneId ? props.filters.otherFilters.geoZoneId : ""}
          options={props.filters.datos ? props.filters.datos.geoZones : []}
          onChange={props.handleSubmit}
          className={"geoZoneFilter"}
          dataAttributes={{
            "data-selectid": "geoZoneId",
            "data-selectfilter": true,
            "data-value": (option) => option.key,
          }}
        />
        {
          showFilterWorkingShiftGroup && (
            <SelectFilter
              label={props.language.tasks_manager.filters.workingShiftGroup}
              selectedKey={props.filters.otherFilters.workingShiftGroup ? props.filters.otherFilters.workingShiftGroup : ""}
              options={props.filters.datos ? props.filters.datos.workingShiftGroups : []}
              onChange={props.handleSubmit}
              className={"workingShiftGroupFilter"}
              dataAttributes={{
                "data-selectid": "workingShiftGroup",
                "data-selectfilter": true,
                "data-value": (option) => option.key,
              }}
            />
          )
        }
      </div>
    </section>
  )
};

export default Filters;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/filters.jsx